import { atom } from 'jotai';

export const ncwPrivacyModeAtom = atom<boolean>(false);
